export const scrollToTop = () => {
  window.scroll({
    top: 0,
    behavior: 'smooth',
  });
};
